import { useApp } from '../context/AppContext';

const NAV_ITEMS = [
  { view: 'dashboard', label: 'Dashboard', icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  )},
  { view: 'families', label: 'Families', icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  )},
  { view: 'expenses', label: 'Expenses', icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="1" x2="12" y2="23"/>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  )},
  { view: 'settlement', label: 'Settlement', icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  )},
  { view: 'info', label: 'Trip Info', icon: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="16" x2="12" y2="12"/>
      <line x1="12" y1="8" x2="12.01" y2="8"/>
    </svg>
  )},
];

export default function Sidebar({ currentView, onNavigate, isOpen, onClose }) {
  const { exportData, resetAll, showToast } = useApp();

  const handleReset = () => {
    if (window.confirm('Reset ALL data? This cannot be undone.')) {
      resetAll();
      showToast('All data reset', 'info');
    }
  };

  return (
    <>
      {isOpen && <div className="sidebar-backdrop" onClick={onClose} />}
      <aside className={`sidebar${isOpen ? ' open' : ''}`} id="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo"><span>✈️</span> Tour Expenses</div>
          <div className="sidebar-subtitle">Family Trip Tracker</div>
        </div>

        <nav className="nav">
          {NAV_ITEMS.map(item => (
            <button
              key={item.view}
              className={`nav-item${currentView === item.view ? ' active' : ''}`}
              onClick={() => { onNavigate(item.view); onClose(); }}
            >
              {item.icon}
              {item.label}
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="btn btn-ghost" onClick={exportData} style={{ marginBottom: '4px' }}>📤 Export Data</button>
          <button className="btn btn-ghost" onClick={handleReset} style={{ color: 'var(--accent-red-light)' }}>🗑️ Reset All</button>
        </div>
      </aside>
    </>
  );
}
